import { useTerritoriosStore } from '@/store/territorios'
import { useApi } from '@/composables/useApi'

// Centro del territorio: centroide del polígono; si no hay límites, primer
// punto de manzanas (mzNumbers[0] = centro por convención); si no, null.
const computeCenter = (d) => {
  if (d.limits.length) {
    const n = d.limits.length
    const lat = d.limits.reduce((s, p) => s + p[0], 0) / n
    const lng = d.limits.reduce((s, p) => s + p[1], 0) / n
    return [lat, lng]
  }
  if (d.mzNumbers.length) {
    const ll = d.mzNumbers[0][0]
    return [ll.lat, ll.lng]
  }
  return null
}

// Mapea un draft local al payload esperado por la API, con la misma forma que
// useTerritorioStore().getData() (defaults para los campos no capturados aquí).
const buildPayload = (d, zoom) => ({
  uuid: d.uuid,
  numero: d.numero,
  zona: d.zona,
  center: computeCenter(d),
  color: JSON.parse(JSON.stringify(d.color)),
  mapConfig: {},
  limits: JSON.parse(JSON.stringify(d.limits)),
  mzNumbers: JSON.parse(JSON.stringify(d.mzNumbers)),
  puntoEncuentro: JSON.parse(JSON.stringify(d.puntoEncuentro)),
  tipo: d.tipo || 'default',
  routes: [],
  shape: 0,
  angle: -19,
  zoom,
  referencia: d.referencia || '',
  notas: d.notas || '',
  caracteristicas: {
    tamanoGrupo: null,
    aptoDuranteLluvia: null,
    aptoLuegoDeLluvia: null,
    tipoVehiculo: [],
    seguridad: null,
    nivelProductividad: null,
    publicadoresCerca: '',
    observaciones: '',
  },
  estudios: [],
  transporte: [],
})

export const useSaveTerritoriosMasivo = () => {
  const territorios = useTerritoriosStore()
  const api = useApi()

  // Guarda cada draft con upsert individual (PUT /api/territories/:id).
  // NO usa el PUT masivo /api/territories porque ese borra todos los
  // territorios del scope antes de insertar.
  const execute = async (drafts, { zoom = 17 } = {}) => {
    const result = { saved: [], skipped: [], errors: [] }

    for (const d of drafts) {
      if (!d.numero || d.limits.length < 3) {
        result.skipped.push(d)
        continue
      }
      const data = buildPayload(d, zoom)
      try {
        await territorios.update(data)
        const r = await api.put(`/api/territories/${data.uuid}`, data)
        if (r?.error) result.errors.push({ draft: d, error: r.error })
        else result.saved.push(d)
      } catch (e) {
        result.errors.push({ draft: d, error: e?.message || 'Error de red' })
      }
    }

    return result
  }

  return { execute }
}
